if (!customElements.get('best-sellers-carousel')) {
  customElements.define(
    'best-sellers-carousel',
    class BestSellersCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-best-sellers-track]');
        this.items = [...this.querySelectorAll('.best-sellers__item')];
        this.previousButton = this.querySelector('[data-best-sellers-previous]');
        this.nextButton = this.querySelector('[data-best-sellers-next]');
        this.status = this.querySelector('[data-best-sellers-status]');
        if (!this.track || !this.items.length) return;

        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
        this.track.addEventListener('scroll', () => this.queueUpdate(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      itemStep() {
        const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap || 0);
        return this.items[0].getBoundingClientRect().width + gap;
      }

      visibleCount() {
        return Math.max(1, Math.round(this.track.clientWidth / this.itemStep()));
      }

      pageCount() {
        return Math.max(1, Math.ceil(this.items.length / this.visibleCount()));
      }

      currentPage() {
        const pageWidth = this.itemStep() * this.visibleCount();
        return Math.min(this.pageCount() - 1, Math.max(0, Math.round(this.track.scrollLeft / pageWidth)));
      }

      move(direction) {
        this.track.scrollBy({
          left: direction * this.itemStep() * this.visibleCount(),
          behavior: 'smooth',
        });
      }

      queueUpdate() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }

      update() {
        const page = this.currentPage();
        const pages = this.pageCount();
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth - 2);
        if (this.previousButton) this.previousButton.disabled = this.track.scrollLeft <= 2;
        if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxScroll;
        if (this.status) this.status.textContent = `Page ${page + 1} of ${pages}`;
      }
    }
  );
}

